import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchPayrollStaff } from "../../../../Store/Slices/Finance/payroll/payroll.thunk";
import { useTranslation } from "react-i18next";

const SelectStaffs = ({ staffIds, setStaffIds }) => {  
  const dispatch = useDispatch();
  const [staffs, setStaffs] = useState([]);
  const [staffType, setStaffType] = useState("staff");
  const { t } = useTranslation("prtFinance");
  useEffect(() => {
    getStaff("staff");
  }, []);

  const getStaff = (type) => {
    setStaffType(type);
    dispatch(fetchPayrollStaff({ type })).then((action) => {
      setStaffs(action?.payload?.data || []);
    });
  };

  const handleEntityCheckboxChange = (e, staffId) => {
    if (e.target.checked) {
      setStaffIds((prevIds) => [...prevIds, staffId]);
    } else {
      setStaffIds((prevIds) => prevIds.filter((id) => id !== staffId));
    }
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setStaffIds(staffs.map((staff) => staff._id));
    } else {
      setStaffIds([]);
    }
  };

  return (
    <div className="p-4 bg-white rounded-xl shadow border w-full">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-4">
        <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            checked={staffIds?.length === staffs?.length}
            onChange={handleSelectAllChange}
            className="accent-purple-600 w-4 h-4"
          />
          {t("Select All Staff")}
        </label>

        <select
          onChange={(e) => getStaff(e.target.value)}
          value={staffType}
          className="border-gray-300 rounded-xl px-3 py-1 text-sm focus:ring-purple-500 focus:border-purple-500"
        >
          {["staff"].map((i) => (
            <option key={i} value={i}>
              {i.charAt(0).toUpperCase() + i.slice(1)}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap flex-row  gap-4 items-center justify">
        {staffs?.length > 0 ? (
          staffs.map((staff) => (
            <div
              key={staff._id}
              className="w-[48%] p-3 rounded-xl bg-purple-100 text-purple-800 border border-purple-200 shadow-sm hover:shadow-md transition"
            >
              <label className="inline-flex items-start gap-2">
                <input
                  type="checkbox"
                  checked={staffIds.includes(staff._id)}
                  onChange={(e) => handleEntityCheckboxChange(e, staff._id)}
                  className="mt-1 accent-purple-600"
                />
                <div className="flex flex-col">
                  <p className="font-medium text-sm whitespace-nowrap">
                    {staff.firstName} {staff.lastName}
                  </p>
                  <p className="text-xs text-purple-700 whitespace-nowrap">
                    {staff.email}
                  </p>
                </div>
              </label>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-500 py-4">
            {t("No Staff Found")}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectStaffs;
